import {
  type PermissionMapping,
  ResourceAccessState,
} from "@eai-toolkit/client";
import {
  BlockOutlined,
  CheckCircleOutline,
  ErrorOutline,
  HourglassEmpty,
} from "@mui/icons-material";
import type { SvgIcon } from "@mui/material";

import type { StateColorFn } from "../../../data/fieldRenderers/State";
import type { ResourceType } from "../../../store/api/resourceTypes";

export function accessRequestStateDescription(
  state: string | undefined,
): string {
  switch (state) {
    case ResourceAccessState.PENDING:
      return "Request is pending approval";
    case ResourceAccessState.APPROVED:
      return "Request was approved";
    case ResourceAccessState.REJECTED:
      return "Request was rejected";
    case ResourceAccessState.CANCELLED:
      return "Request was cancelled";
    case ResourceAccessState.EXPIRED:
      return "Request has expired";
    default:
      return "";
  }
}

export function getStateIcon(state: string | undefined): typeof SvgIcon {
  switch (state) {
    case ResourceAccessState.APPROVED:
      return CheckCircleOutline;
    case ResourceAccessState.REJECTED:
      return ErrorOutline;
    case ResourceAccessState.CANCELLED:
      return BlockOutlined;
    case ResourceAccessState.EXPIRED:
    case ResourceAccessState.PENDING:
    default:
      return HourglassEmpty;
  }
}

export const getStateBackgroundColor: StateColorFn = (state, palette) => {
  switch (state) {
    case ResourceAccessState.PENDING:
      // TODO: decide on shade of yellow
      // return palette.warning.light; // This is more of an orange
      return "#c9a000"; // Golden yellow
    case ResourceAccessState.APPROVED:
      return palette.success.light;
    case ResourceAccessState.REJECTED:
      return palette.error.light;
    case ResourceAccessState.CANCELLED:
      return palette.grey[600];
    case ResourceAccessState.EXPIRED:
      return palette.grey[400];
    default:
      return palette.text.secondary;
  }
};

export const getStateTextColor: StateColorFn = (state, palette) => {
  switch (state) {
    // Right now everything looks best as white, but keeping this in case later we need dark text for some states
    // case "PENDING":
    //   return palette.warning.dark;
    default:
      return palette.common.white;
  }
};

export function getResourceTypeFromAction(
  action: string | undefined,
  permissionMappings: PermissionMapping[],
): ResourceType | undefined {
  if (!action) {
    return undefined;
  }
  const mapping = permissionMappings.find((m) => m.action === action);
  const resourceType = mapping?.resourceType;
  if (
    resourceType === "data" ||
    resourceType === "job" ||
    resourceType === "service" ||
    resourceType === "account"
  ) {
    return resourceType;
  }
  return undefined;
}
